import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-obsidian text-ivory">
      {/* Header */}
      <header className="border-b border-amber/[0.08] bg-obsidian/95 backdrop-blur-sm">
        <div className="max-w-4xl mx-auto px-6 py-5">
          <Link to="/" className="inline-flex items-center gap-2 text-amber hover:text-amber/80 transition-colors font-body text-sm">
            <ArrowLeft size={16} />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl md:text-5xl font-light text-ivory mb-4">Terms of Service</h1>
        <p className="text-ivory/30 font-body text-sm mb-12">Last updated: February 2026</p>

        <div className="space-y-8 font-body text-ivory/70 leading-relaxed">
          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">1. Acceptance of Terms</h2>
            <p>By accessing and using The Curated Experience website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">2. Booking and Reservations</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>All bookings are subject to availability</li>
              <li>A valid phone number is required for all reservations</li>
              <li>Bookings are confirmed only after successful payment</li>
              <li>We reserve the right to refuse service to anyone</li>
              <li>Booking slots are non-transferable without prior approval</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">3. Payment Terms</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>All prices are in Indian Rupees (INR)</li>
              <li>Payment is required at the time of booking</li>
              <li>We accept payments through Razorpay (UPI, Cards, Net Banking)</li>
              <li>Prices are subject to change without prior notice</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">4. Guest Conduct</h2>
            <p className="mb-4">Guests are expected to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Arrive on time for their scheduled slot</li>
              <li>Maintain respectful behavior towards staff and other guests</li>
              <li>Follow safety guidelines provided by our team</li>
              <li>Not engage in any illegal activities on the premises</li>
              <li>Keep the venue clean and dispose of waste properly</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">5. BYOB Policy</h2>
            <p>Guests are allowed to bring their own alcoholic beverages. However:</p>
            <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
              <li>Consumption must be responsible</li>
              <li>Guests must be of legal drinking age (21+)</li>
              <li>We reserve the right to refuse entry to intoxicated guests</li>
              <li>Driving under influence is strictly prohibited</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">6. Weather Policy</h2>
            <p>In case of inclement weather (heavy rain, storms), we will:</p>
            <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
              <li>Notify you in advance if conditions are unsuitable</li>
              <li>Offer rescheduling to the next available date at no extra cost</li>
              <li>Provide full refund if rescheduling is not possible</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">7. Liability</h2>
            <p>The Curated Experience is not liable for:</p>
            <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
              <li>Personal belongings lost or damaged on the premises</li>
              <li>Injuries resulting from guest negligence</li>
              <li>Vehicle damage in the parking area</li>
              <li>Any consequences of alcohol consumption</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">8. Intellectual Property</h2>
            <p>All content on this website, including text, images, logos, and design, is the property of The Curated Experience and protected by copyright laws.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">9. Changes to Terms</h2>
            <p>We reserve the right to modify these terms at any time. Continued use of our services after changes constitutes acceptance of the new terms.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">10. Contact Us</h2>
            <p className="mb-2">For any questions regarding these Terms of Service:</p>
            <p className="text-amber">Email: support@tcexp.in</p>
            <p className="text-amber">Phone: +91 8876133284</p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-amber/[0.08] py-8">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-ivory/30 font-body text-sm">© 2026 The Curated Experience. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
